import { IApplicationState } from '../../types/redux';

export function getHasTour(state: IApplicationState): boolean {
  return state.offersData?.newbuildingPromoSnippet?.newbuilding.hasTour || false;
}
